import { ModelFactory } from '@shared/factories/model.factory';
import { ServiceCategoryType } from '@generated/graphql';
import { ServiceCategory } from '@modules/service/models/service-category.model';

export class ServiceCategoryFactory extends ModelFactory<ServiceCategoryType, ServiceCategory> {
  create (state: ServiceCategoryType): ServiceCategory {
    return new ServiceCategory(state);
  }
}

export const serviceCategoryFactory = new ServiceCategoryFactory();
